// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useCallback, useContext,
    useEffect, useMemo, useState} from 'react';
import cn from 'classnames';
import {Button} from '../../../../hola/pub/lib/button';
import {Modal} from '../../../../hola/pub/lib/modal';
import {Slider} from '../slider/slider';
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';
import Svg_gift_opened from '../../img/dashboard/gift_opened_with_shadow.svg';
import Icon_globe from '../../img/icons/16/globe.svg';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Flag} from '../../../../hola/pub/lib/flag';
// @ts-ignore
import {code2label} from 'zcountry';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
import etask from 'zetask';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {t_country} from '../dashboard/country_list';
// @ts-ignore
import {get_country_object} from '/util/country.js';
import {i_user_info} from 'hola_app_context';
import {t_countries, t_free_zone_params} from '../../lib/use_dashboard_data';
import {useHistory} from 'react-router';
import {use_app_context} from '../../lib/app_context';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from '../../pages/toolip.io/dashboard.module.less';
import {Country_selector_v2} from './country_selector_v2';

const create_free_proxy_url = '/api/create_free_by_type';
const PROXY_TYPES = [Proxy_type.SDC, Proxy_type.DDC, Proxy_type.ISP,
    Proxy_type.ISPPREM, Proxy_type.RES];
const ORDER_TYPE_PARAMS = {
    [Proxy_type.SDC]: {
        title: 'Shared Datacenter Proxy',
        show_country_selector: true,
    },
    [Proxy_type.DDC]: {
        title: 'Dedicated Datacenter Proxy',
        show_country_selector: true,
    },
    [Proxy_type.ISP]: {
        title: 'Global ISP Proxy',
        show_country_selector: true,
    },
    [Proxy_type.ISPPREM]: {
        title: 'Search Engine ISP Proxy',
        show_country_selector: false,
        country: 'us',
    },
    [Proxy_type.RES]: {
        title: 'Rotating Residential Proxy',
        show_country_selector: false,
    },
};

export interface i_promo_state {
    selected_slide_idx: number;
    selected_proxy_type?: Proxy_type;
}

interface i_welcome_promo_dialog_props {
    user?: i_user_info;
    is_promo_open: boolean;
    close_dialog: (v: boolean)=>void;
    init_state?: i_promo_state;
}

const Welcome_promo_slider = (props: i_welcome_promo_dialog_props)=>{
    const {user, close_dialog, init_state = {selected_slide_idx: 0}} = props;
    const {dashboard} = use_app_context();
    const [state, set_state] = useState<i_promo_state>(init_state);
    const close = ()=>close_dialog(false);
    const update_state = useCallback((new_state: Partial<i_promo_state>)=>
        set_state(prev=>({...prev, ...new_state})), []);
    const next_slide = useCallback(()=>
        set_state(prev=>({...prev,
            selected_slide_idx: ++prev.selected_slide_idx})), []);
    const set_slide = useCallback((idx:number)=>
        set_state(prev=>({...prev,
            selected_slide_idx: idx})), []);
    const [countries, set_countries] = useState<t_countries|null>(null);
    useEffect(()=>{
      fetch('/api/countries')
          .then(res=>set_countries(res?.res??null));
    }, []);
    return <Slider wrapper_cls={styles.promo_dialog}
      select_slide={set_slide}
      selected_idx={state.selected_slide_idx}
      slides={[
        {content: <Slide_welcome state={state} close={close}
          next_slide={next_slide} update_state={update_state} />},
        {content: <Slide_select_type state={state} close={close}
          next_slide={next_slide} update_state={update_state} />},
        {content: <Slide_selected_proxy state={state} close={close}
          next_slide={next_slide} update_state={update_state}
          set_free_zone_params={params=>dashboard.dispatch(
            {type: 'set_free_zone_params', payload: {params}})}
          refresh_orders={()=>dashboard.dispatch({type: 'refresh_orders'})}
          countries={countries?.[state.selected_proxy_type]}
          has_user={!!user} />,
          disabled: !state.selected_proxy_type},
      ]}
    />;
};

export const Welcome_promo_dialog = (props: i_welcome_promo_dialog_props)=>{
    const {is_promo_open, close_dialog} = props;
    return <Modal width={574} is_open={is_promo_open} content_when_open
      on_close={()=>close_dialog(false)} on_overlay_click={()=>undefined}>
      {is_promo_open && <Welcome_promo_slider {...props}/>}
    </Modal>;
};

interface i_slide_props {
    has_user?: boolean;
    state: i_promo_state;
    countries?: string[];
    country?: string;
    update_state: (n: Partial<i_promo_state>)=>void;
    next_slide: ()=>void;
    close: ()=>void;
    set_free_zone_params?: (params?: t_free_zone_params)=>void;
    refresh_orders?:()=>void;
}

const Slide_welcome = (props: i_slide_props)=>{
    const {theme} = useContext(Settings_context);
    return <div className={styles.promo_slide_welcome}>
      <div className={cn(styles.gradient_wrapper, styles.mb16)}>
        <Lottie src={toolip_img_url('animation/present.json')}
          width="84px" height="147px" autoplay/>
      </div>
      <h4>Welcome to tooltip &#127881;</h4>
      <p className={cn(theme.p16, theme.color_n500)}>
        Great news! We're giving your a free plan to get you started.
        Go ahead and choose the type of Proxy you'd like to experience
        first, on the house!</p>
      <Button color={'black'} round={false}
        cls={cn(styles.promo_btn, styles.mt16)}
        on_click={props.next_slide} caption={'Let\'s get started'} />
    </div>;
};

const type_to_option_cn = {
    [Proxy_type.SDC]: styles.option_shared_dc,
    [Proxy_type.DDC]: styles.option_dedicated_dc,
    [Proxy_type.ISP]: styles.option_isp,
    [Proxy_type.ISPPREM]: styles.option_isp_plus,
    [Proxy_type.RES]: styles.option_smart_resi,
};
const idx_to_hero_anim = [styles.hero_showup_1, styles.hero_showup_2,
    styles.hero_showup_3, styles.hero_showup_4, styles.hero_showup_5];

const Slide_select_type = (props: i_slide_props)=>{
    const {state, update_state} = props;
    const {theme} = useContext(Settings_context);
    return <div className={styles.promo_slide_proxies}>
      <p className={cn(theme.p18, theme.med, styles.mb12)}>
        Which Free proxy would you like as a gift from us?</p>
      {PROXY_TYPES.map((proxy, idx)=>
        <div
          key={proxy}
          className={cn(styles.proxy_option,
            !state.selected_proxy_type && idx_to_hero_anim[idx],
            type_to_option_cn[proxy],
            state.selected_proxy_type == proxy && styles.selected)}>
          <input
            type="radio"
            id={proxy}
            value={proxy}
            checked={state.selected_proxy_type === proxy}
            onChange={()=>update_state({selected_proxy_type: proxy})}
          />
          <label htmlFor={proxy} className={cn(theme.P, theme.p16, theme.med)}>
            {ORDER_TYPE_PARAMS[proxy].title}
          </label>
        </div>
      )}
      {state.selected_proxy_type && <Button color={'black'} round={false}
        on_click={props.next_slide} cls={cn(styles.promo_btn, styles.mt12)}
        caption={'Choose'} />}
    </div>;
};

const Slide_selected_proxy = (props: i_slide_props)=>{
    const {state} = props;
    return <div className={styles.promo_slide_welcome}>
      <div className={cn(styles.gradient_wrapper, styles.mb24)}>
        <Svg_gift_opened/>
      </div>
      {state.selected_proxy_type &&
        <Proxy_final {...props}/>}
    </div>;
};

const Btn_loader = ()=>{
    return <Lottie autoplay loop width="96" height="96"
      src={toolip_img_url('animation/toolip_loader_72_grey.json')}/>;
};

const get_country_objects = (countries: string[])=>{
  return countries
      ?.map(x=>get_country_object(x))
      ?.sort((a, b)=>a.name_low.localeCompare(b.name_low)) ?? [];
};

const Proxy_final = (props: i_slide_props)=>{
    const history = useHistory();
    const {state, has_user, set_free_zone_params, close, refresh_orders,
        countries=[]} = props;
    const {selected_proxy_type} = state;
    const params = ORDER_TYPE_PARAMS[selected_proxy_type];
    const {theme} = useContext(Settings_context);
    const [is_busy, set_is_busy] = useState(false);
    const [err, set_err] = useState(false);
    const [country, set_country] = useState(params.country ?? null);
    const country_objects: t_country[] = useMemo(()=>
      get_country_objects(countries), [countries]);
    const create_free_proxy = ()=>etask(function*(){
        if (!has_user)
        {
            set_free_zone_params({type: selected_proxy_type, country});
            close();
            return;
        }
        set_is_busy(true);
        set_err(false);
        try {
            yield fetch(create_free_proxy_url, {
                method: 'POST',
                body: {type: selected_proxy_type, country},
            });
            refresh_orders?.();
            close();
            history.push('/dashboard/page/plans');
        } catch(e){
            set_err(true);
        }
        set_is_busy(false);
    });
    return <Fragment>
      <p className={cn(theme.p18, theme.med)}>
        Here is your Free {params.title}!</p>
      <p className={cn(theme.p14, theme.color_n400, theme.med, styles.mb8)}>
        {params.show_country_selector
          ? `All you need to do now is to choose a country and generate it and
            you're all set to try out toolip for 3 days!`
          : `All you need to do now is generate it and you're all set to try
            out toolip for 3 days!`
        }
      </p>
      {!params.show_country_selector && params.countries &&
        <div className={styles.countries}>
          {params.countries.map(([code, count])=>
              <span key={code}
                data-tt="Toolip has more than 190 IP locations!
                  The free plan includes these 3 countries to test our proxies"
                className={cn(theme.P, theme.p14, theme.med,
                  styles.country, styles.purple)}>
                <Flag country={code} size={16} round/>
                {code2label(code)}
                <span className={cn(styles.country_count, theme.P, theme.p12)}>
                  {count}</span>
            </span>
          )}
      </div>}
      {selected_proxy_type==Proxy_type.RES && <span
        className={cn(styles.chip, theme.P, theme.p14, theme.med)}>
        <Icon_globe/>
        0.1 GB Bandwidth - Unlimited sessions</span>}
      {params.show_country_selector &&
        <div className={styles.country_selector}>
          <Country_selector_v2
            all={country_objects}
            country={country}
            with_empty_option
            on_country_change={set_country}
            cls={styles.c_list}
            item_cls={styles.c_item}
            with_filter
          />
          <Button color={'black'} round={false}
            cls={cn(styles.btn_w_220, styles.promo_btn)}
            on_click={create_free_proxy} disabled={is_busy || !country}
            caption={is_busy ? <Btn_loader/> : 'Generate'} />
        </div>}
      {err && <div className={styles.err_msg}>
        Something went wrong</div>}
      {!params.show_country_selector &&
        <Button color={'black'} round={false}
          cls={cn(styles.btn_w_220, styles.promo_btn)}
          on_click={create_free_proxy} disabled={is_busy}
          caption={is_busy ? <Btn_loader/> : 'Generate'} />}
      {selected_proxy_type==Proxy_type.ISP && <p
        className={cn(styles.note, theme.p12, theme.color_n400)}>
        Please note: this product allows you to scrape any website,
        except for search engines and social media platforms.</p>}
      {selected_proxy_type==Proxy_type.ISPPREM && <p
        className={cn(styles.note, theme.p12, theme.color_n400)}>
        Please note: this product is available only in the US and allows
        scraping of any website, including search engines
        and social media platforms.</p>}
    </Fragment>;
};
